<ng-container *ngIf="page$ | async as home">
  <ng-container *ngIf="home?.data.attributes?.banner">
    <widget-banner [widget]="home.data.attributes.banner" (search)="onSearch($event)"></widget-banner>
  </ng-container>
</ng-container>

<ng-container *ngIf="commigSoon">
  <div class="py-60 max-w-screen-xl m-auto">
    <h4 class="text-6xl">{{ "Coming soon" | transloco }}</h4>
  </div>
</ng-container>

<ng-container *ngIf="!commigSoon">
  <ng-container *ngIf="items$ | async as resultSolr">
    <header class=" flex flex-col w-full">
      <div class="flex justify-between w-full max-w-screen-xl mx-auto px-4 md:px-14 pt-7">
        <mat-form-field class="w-52 border-red-motorbest-600 text-red-motorbest-600 rounded-none">
          <mat-select value="select1-1" class="border-red-motorbest-600 text-red-motorbest-600 rounded-none"
            [(ngModel)]="searchSort" (selectionChange)="findProducts()">
            <mat-option value="published_at_dt desc">
              {{ "Most Recent" | transloco }}
            </mat-option>
            <mat-option value="published_at_dt asc">
              {{ "Older" | transloco }}
            </mat-option>
            <mat-option value="name_s asc">
              {{ "Sort A-Z" | transloco }}
            </mat-option>
            <mat-option value="name_s desc">
              {{ "Sort Z-A" | transloco }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-stroked-button class="border-red-motorbest-600 rounded-none"
          [ngClass]="{'bg-red-motorbest-600': filtersOpen,'text-white': filtersOpen, 'text-red-motorbest-600': !filtersOpen}"
          (click)="toggleFilters()">
          <mat-icon svgIcon="mat_outline:filter_list" class="icon-size-4 mr-4"
            [ngClass]="{'text-white': filtersOpen, 'text-primary':!filtersOpen}"></mat-icon>
          {{ "Filters" | transloco }}
        </button>
      </div>
      <ng-container *ngIf="facets$ | async as facets">
        <app-filters [facets]="facets" [solrFacets]="resultSolr.facets" (filter)="handleFilterEvent($event)"
          [facetsSelected]="facetSelectedEvent" *ngIf="filtersOpen"></app-filters>
      </ng-container>
    </header>

    <section class="max-w-screen-xl mx-auto px-4 md:px-14  w-full marketplace__list--wrapper">
      <h2 class="pb-3 widget-title mb-8 text-3xl" *ngIf="resultSolr.numFound">
        <span class="pb-3">
          {{ resultSolr.numFound }} {{ "automobilia for sale" | transloco }}
        </span>
      </h2>

      <div class="grid grid-cols-1 gap-4  sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 marketplace__list--items"
        *ngIf="resultSolr.numFound">
        <product-card [product]="product" *ngFor="let product of resultSolr.products" class="col-auto"></product-card>
      </div>

      <div class="grid grid-cols-1 gap-4  sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 marketplace__list--items"
        *ngIf="!resultSolr.numFound">
        <div class="flex flex-col justify-center items-center min-h-120 gap-4 col-span-1 md:col-span-2 lg:col-span-4">
          <mat-icon svgIcon="feather:tool" class="icon-size-24 text-slate-200"></mat-icon>
          <div class="text-2xl font-bold leading-3xl">{{'Advertise your automobilia today' | transloco}}</div>
          <div class="max-w-100 text-center hidden">
            {{'There are no ads to manage at the moment, click the button below to start selling' | transloco}}
          </div>

          <button mat-raised-button [color]="'primary'" class="rounded-none flex gap-4"
            [routerLink]="['/',activeLang,'private','my-products','announce' | transloco]">
            <mat-icon svgIcon="mat_solid:margin"></mat-icon>
            {{'Criar a minha conta e comerçar a vender' | transloco}}
          </button>
        </div>
      </div>
    </section>
    <section class="max-w-screen-xl mx-auto px-4 md:px-14 py-7 ">
      <div class="flex justify-center">
        <tx-pagination #pagination [collectionSize]="resultSolr.numFound" [pageSize]="page.pageSize"
          [firstLastButtons]="false" [maxSize]="3" [previousLabel]="'Previous' | transloco "
          [nextLabel]="'Next' | transloco " (page)="handlePageEvent($event)"></tx-pagination>
      </div>
    </section>
  </ng-container>
</ng-container>